import React from 'react';

const RoleManagement = () => {
  return (
    <div>
      <h2>Role Management</h2>
      {/* TODO: Assign/edit roles */}
    </div>
  );
};

export default RoleManagement;
